//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import newApi from '@/utils/newModuleApi'
import FeatureGuidePanel from '@/components/new/FeatureGuidePanel.vue'

export default {
  components: { FeatureGuidePanel },
  data () {
    return { count: {}, categoryId: null }
  },
  computed: {
    progressPercent () {
      const total = this.count.total_count || 0
      const done = this.count.reviewed_today || 0
      if (total === 0) return done > 0 ? 100 : 0
      return Math.min(100, Math.round(done * 100 / total))
    }
  },
  created () {
    this.categoryId = this.$route.query.categoryId || null
    this.loadCount()
  },
  methods: {
    loadCount () {
      let url = newApi.reviewTodayCount
      if (this.categoryId) url += '?category_id=' + this.categoryId
      this.$ajax.get(url).then(res => { this.count = res || {} }).catch(() => {})
    },
    startReview (type) {
      this.$router.push({
        path: '/reviewPractice_display',
        query: {
          review_type: type,
          categoryId: this.categoryId,
          isWordPower: this.$route.query.isWordPower,
          from: this.$route.query.from
        }
      })
    },
    goBack () {
      if (this.$route.query.from === 'mine') {
        this.$router.push({ path: '/mine', query: { hideTrans: 'true' } })
        return
      }
      if (this.$route.query.from === 'practice') {
        this.$router.push({ path: '/practice', query: { hideTrans: 'true' } })
        return
      }
      this.$router.push({ path: '/home', query: { hideTrans: 'true' } })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/new/review/home.vue